import script from "./HostingList.vue?vue&type=script&setup=true&lang=js"
export * from "./HostingList.vue?vue&type=script&setup=true&lang=js"

import "./HostingList.vue?vue&type=style&index=0&id=e00a5c54&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e00a5c54"]])

export default __exports__